import { render, staticRenderFns } from "./contentArea.vue?vue&type=template&id=24092033&"
import script from "./contentArea.vue?vue&type=script&lang=js&"
export * from "./contentArea.vue?vue&type=script&lang=js&"
import style0 from "./contentArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports